var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SliderWidget',{attrs:{"itemsToShow":_vm.itemsToShow,"list":_vm.list},scopedSlots:_vm._u([{key:"item",fn:function(item){return [_c(_vm.component,_vm._b({tag:"component"},'component',item,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }